import content, { getPage } from '../../content.js'

export default
{
    props:
    {
        currentPage: { type: String }
    },

    data()
    {
        return {
            mainPages: [
                getPage('products'),
                getPage('story'),
                getPage('mission'),
                getPage('eating')
            ],
            secondsPages: [
                getPage('policy'),
                getPage('terms')
            ],
            mailto: content.mailto
        }
    },

    mounted()
    {
        document.body.classList.add('is-menu-open')
    },

    destroyed()
    {
        document.body.classList.remove('is-menu-open')
    },

    methods:
    {
        close()
        {
            this.eventHub.$emit('menu:close')
        },

        openSubscribe()
        {
            this.eventHub.$emit('subscribe:open')
        }
    }
}